class SmoothScroll {
	constructor(config) {
		this.config = Object.assign({
			scope: 'body'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		setTimeout(function () {
			document.documentElement.style.setProperty('--scroll-behavior', 'smooth');
		}, 100);
	}
}

export default new SmoothScroll;
